import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';

const SlidingEmailForm = ({ onSubmit, onClose, show }) => {
  const [emailText, setEmailText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      await onSubmit(emailText);
      setEmailText('');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!show) return null;

  return (
    <div className={`email-form-container mb-3 ${show ? 'slide-down' : ''}`}>
      <Form onSubmit={handleSubmit}>
        <Form.Control
          as="textarea"
          rows={3}
          value={emailText}
          onChange={(e) => setEmailText(e.target.value)}
          placeholder="Type your message here..."
          className="email-textarea mb-2"
        />
        <div className="d-flex justify-content-end gap-2">
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            size="sm"
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Sending...' : 'Send'}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default SlidingEmailForm;